import type { IUserRepository } from '../../domain/repositories/UserRepository';
import type { User } from '../../domain/entities/User';
import type { Result } from '../../shared/types/common.types';

export interface IGetUserUseCase {
  execute(id: string): Promise<Result<User>>;
  executeByEmail(email: string): Promise<Result<User>>;
}

export class GetUserUseCase implements IGetUserUseCase {
  private readonly userRepository: IUserRepository;

  constructor(userRepository: IUserRepository) {
    this.userRepository = userRepository;
  }

  async execute(id: string): Promise<Result<User>> {
    if (!id) {
      return { success: false, error: new Error('User ID is required') };
    }

    return await this.userRepository.findById(id);
  }

  async executeByEmail(email: string): Promise<Result<User>> {
    if (!email) {
      return { success: false, error: new Error('Email is required') };
    }

    return await this.userRepository.findByEmail(email);
  }
}
